// extracted by mini-css-extract-plugin
export default {"item":"SavedCard-module_item__fjvPR","brandIcon":"SavedCard-module_brandIcon__k4BYt","removeIcon":"SavedCard-module_removeIcon__kWVTZ"};